import { render, staticRenderFns } from "./VueImageEditor.vue?vue&type=template&id=0f2352a0&scoped=true&"
import script from "./VueImageEditor.vue?vue&type=script&lang=js&"
export * from "./VueImageEditor.vue?vue&type=script&lang=js&"
import style0 from "./VueImageEditor.vue?vue&type=style&index=0&id=0f2352a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2352a0",
  null
  
)

export default component.exports